export default "__VITE_ASSET__D65AyhAR__"